import * as Types from '../../../../generated/base-types';

import { gql } from 'apollo-angular';
import { CategoryFragmentDoc } from './load-dimensions.generated';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type UpdateCategoryMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
  attributes: Types.CategoryInput;
}>;


export type UpdateCategoryMutation = { __typename?: 'Mutation', updateCategory?: { __typename?: 'UpdateCategoryPayload', successful: boolean, category?: { __typename?: 'Category', id: string, name: string, nameDe?: string | null, nameEn?: string | null, nameFr?: string | null, nameIt?: string | null, position: number, customIdentifier?: string | null, dimension: { __typename?: 'Dimension', id: string } } | null } | null };

export const UpdateCategoryDocument = gql`
    mutation UpdateCategory($id: ID!, $attributes: CategoryInput!) {
  updateCategory(id: $id, attributes: $attributes) {
    category {
      ...Category
    }
    successful
  }
}
    ${CategoryFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCategoryGQL extends Apollo.Mutation<UpdateCategoryMutation, UpdateCategoryMutationVariables> {
    document = UpdateCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }